import ProfileModel from './profile-model';
import adamProfile from './profile-pictures/adam.jpeg';

const adam = new ProfileModel({
    username: 'adam',
    password: 'admin',
    profilePicture: adamProfile,
    firstName: 'Adam',
    lastName: 'Dillard',
    files: [
        "//v2.grommet.io/assets/Wilderpeople_Ricky.jpg"
    ],
    key: 0,
})

export default adam;